import * as dayjs from 'dayjs'

import { TimeFormat } from '../../models'

import { format } from './format'

export const formatHour = (hour: number): string =>
  format(TimeFormat.Standard, dayjs().hour(hour).minute(0).second(0).millisecond(0).toDate())
